<template>
  <div class="form-group col-md-7 px-0">
    <label class="text-black" for="region-select">Region</label>
    <b-select
        label-field="Region"
        :options="regions"
        id="region-select" v-model="selectedRegion"
    ></b-select>

  </div>
</template>

<script>
import platformSettings from '~config/settings'
import {mapState} from "vuex";

export default {
  data() {
    return {
      regions: platformSettings.regions.map(region => ({
        text: region, value: region
      }))
    }
  },
  computed: {
    ...mapState('user', ['profile']),
    selectedRegion: {
      get () {
        return this.$store.state.user.profile.region || platformSettings.regions[0]
      },
      set (value) {
        this.$store.commit('user/setProfileUpdate', {region: value})
      }
    }
  }
}
</script>
